import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';

import { setupAjax } from "../../services/ajax/setup";
import { userInfo } from "../../store/actions/user";

import LoginForm from "./Login";

class Auth extends React.PureComponent {
  componentWillReceiveProps(nextProps) {
    if (nextProps.user && !this.props.user) {
      setupAjax();
    }
  }
  render() {
    const { user, component: Component, ...rest } = this.props;
    if (!user) return <LoginForm />
    return (
      <React.Fragment>
        <Component {...rest} />
      </React.Fragment>
    )
  }
}


export default connect(
  state => (
    {
      user: state.user,
    }
  ),
  dispatch => bindActionCreators({
    userInfo
  }, dispatch)
)(Auth)